/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const CalculatorAlt = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 15 20" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path fillRule="evenodd" clipRule="evenodd" d="M14.063.217H.938A.937.937 0 0 0 0 1.15V18.85c0 .513.422.932.938.932h13.125c.516 0 .937-.42.937-.932V1.15a.937.937 0 0 0-.937-.932zm-9.375 17.47c0 .14-.094.232-.234.232H2.109c-.14 0-.234-.093-.234-.233v-2.329c0-.14.094-.233.234-.233h2.345c.14 0 .234.094.234.233v2.33zm0-3.727c0 .14-.094.232-.234.232H2.109c-.14 0-.234-.092-.234-.232v-2.33c0-.14.094-.233.234-.233h2.345c.14 0 .234.094.234.233v2.33zm4.218 3.726c0 .14-.094.233-.234.233H6.328c-.14 0-.234-.093-.234-.233v-2.329c0-.14.094-.233.234-.233h2.344c.14 0 .234.094.234.233v2.33zm0-3.726c0 .14-.094.232-.234.232H6.328c-.14 0-.234-.092-.234-.232v-2.33c0-.14.094-.233.234-.233h2.344c.14 0 .234.094.234.233v2.33zm4.219 3.726c0 .14-.094.233-.235.233h-2.343c-.14 0-.234-.093-.234-.233V11.63c0-.14.093-.233.234-.233h2.343c.141 0 .235.094.235.233v6.056zm-8.437-7.453c0 .14-.094.233-.234.233H2.109c-.14 0-.234-.093-.234-.233v-2.33c0-.139.094-.232.234-.232h2.345c.14 0 .234.093.234.233v2.33zm4.218 0c0 .14-.094.233-.234.233H6.328c-.14 0-.234-.093-.234-.233v-2.33c0-.139.094-.232.234-.232h2.344c.14 0 .234.093.234.233v2.33zm4.219 0c0 .14-.094.233-.235.233h-2.343c-.14 0-.234-.093-.234-.233v-2.33c0-.139.093-.232.234-.232h2.343c.141 0 .235.093.235.233v2.33zm0-4.658c0 .14-.094.233-.235.233H2.11c-.14 0-.235-.093-.235-.233V2.314c0-.14.094-.233.234-.233H12.89c.141 0 .235.093.235.233v3.26z" />
      </g>
    </svg>
  </span>
);

CalculatorAlt.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

CalculatorAlt.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default CalculatorAlt;
